import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToLocalDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import Location from '../../commoncomponents/location';

function PointTable(props) {
  let assetCustomerName = props.assetCustomerName;
  let timeZone = props.timeZone ? props.timeZone.toString().slice(25, 55) : '';
  let createdData = [];
  console.log("poitabel", props)
  if (props.pointData.length > 0) {
    props.pointData.forEach((firstObj) => {
      createdData.push(firstObj);
    });
  }
  console.log("sj createdData", createdData);

  const data = (
    <Table striped>
      <thead>
        <tr className="nowwrapTH">
          <th>ID</th>
          <th>Name</th>

          <th>Entered POI</th>
          <th>Exited POI</th>
          <th>Location</th>

          <th>Duration</th>
          <th>Engine Hours</th>
          <th>Fridge Hours</th>

          <th>Fridge</th>
          <th>TempA</th>
        </tr>
      </thead>
      <tbody>
        {createdData.map((element, index) => {
          console.log("element", element.geoOverlayEvents);
          return (
            <tr>
              <td>{index + 1}</td>
              <td>{element.poiName}</td>
              <td>{utcToLocalDate(element.entered)}</td>
              <td>{utcToLocalDate(element.exited)}</td>
              <td>
                <Location
                  address={element.location}
                  lat={element.latitude}
                  lng={element.longitude}
                />
              </td>
              <td>{element.duration}</td>
              <td>{element.engineDuration}</td>
              <td>{element.fridgeDuration}</td>
              <td>{element.fridge ? "True" : "False"}</td>
              <td>{element.tempA}</td>
            </tr>


          );
        })}
      </tbody>


    </Table>
  );

  const handleDownloadExcel = () => {
    downloadCSVFile(props.pointData, "POIReport", assetCustomerName, timeZone);
  };

  return (
    <ToggleBar
      caption="Point Of Interest"
      icon="fa fa-database"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default PointTable;
